import React from 'react';
import { TimeEntry } from '../../types/time-entry';
import Button from '../Button';

interface TimeEntryCardProps {
  entry: TimeEntry;
  projectName?: string;
  categoryName?: string;
  taskTitle?: string;
  onDelete: (entryId: string) => void;
}

const TimeEntryCard: React.FC<TimeEntryCardProps> = ({
  entry,
  projectName,
  categoryName,
  taskTitle,
  onDelete,
}) => {
  const isCategory = entry.category_id !== null;
  
  return (
    <div
      className={`p-4 rounded-lg border ${
        isCategory
          ? 'bg-accent-50 dark:bg-accent-900/10 border-accent-200 dark:border-accent-800 border-l-4 border-l-accent-500'
          : 'bg-gray-50 dark:bg-gray-800 border-gray-200 dark:border-gray-700 border-l-4 border-l-primary-500'
      }`}
    >
      <div className="flex justify-between mb-1">
        <div className="font-semibold text-gray-900 dark:text-gray-100">
          {new Date(entry.date).toLocaleDateString()}
        </div>
        <div className="flex gap-2 items-center">
          <span className={`font-bold ${isCategory ? 'text-accent-600 dark:text-accent-400' : 'text-primary-600 dark:text-primary-400'}`}>
            {parseFloat(String(entry.hours)).toFixed(1)}h
          </span>
          <Button
            onClick={() => onDelete(entry.id)}
            variant="danger"
            size="sm"
          >
            Delete
          </Button>
        </div>
      </div>
      <div className="text-sm text-gray-700 dark:text-gray-300 mb-1 flex items-center gap-1">
        {isCategory ? (
          <>
            <span className="text-base">📋</span>
            <strong>Non-Productive:</strong> {categoryName}
          </>
        ) : (
          <>
            {projectName}
            {taskTitle && ` • ${taskTitle}`}
          </>
        )}
      </div>
      {entry.description && (
        <div className="text-sm text-gray-600 dark:text-gray-400">
          {entry.description}
        </div>
      )}
      <div className="mt-1 text-xs">
        <span className={`inline-block px-2 py-1 rounded-full mr-1 ${
          entry.billable
            ? 'bg-success/15 text-success'
            : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
        }`}>
          {entry.billable ? 'Billable' : 'Non-billable'}
        </span>
        {isCategory && (
          <span className="inline-block px-2 py-1 rounded-full bg-accent-100 dark:bg-accent-900/20 text-accent-800 dark:text-accent-200">
            Category
          </span>
        )}
      </div>
    </div>
  );
};

export default TimeEntryCard;
